/** 読書進捗と読了時間に関する共通計算。 */

export const normalizeProgressPercentage = (percentage: number): number =>
  Number.isFinite(percentage) ? Math.min(100, Math.max(0, percentage)) : 0;

export const getDisplayProgressPercentage = (percentage: number): number =>
  Math.round(normalizeProgressPercentage(percentage));

export const estimateReadingMinutes = (
  characterCount: number,
  readingSpeed: number,
  progressPercentage = 0,
): number | null => {
  if (
    !Number.isFinite(characterCount) ||
    characterCount <= 0 ||
    !Number.isFinite(readingSpeed) ||
    readingSpeed <= 0 ||
    !Number.isFinite(progressPercentage)
  ) {
    return null;
  }

  const progress = Math.min(100, Math.max(0, progressPercentage));
  if (progress >= 100) return null;

  const remainingCharacters = characterCount * (1 - progress / 100);
  return Math.ceil(remainingCharacters / readingSpeed);
};
